module.exports = __webpack_public_path__ + "img/icon-cog.4e7e01e8.svg";